import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Stack, IconButton } from '@mui/material';
import Iconify from '../../components/iconify';
// ------------------------------------------------------------------------------------------------

ModalPopup.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]),
    cancel: PropTypes.func,
    title: PropTypes.string,
    sx: PropTypes.object,
};
// ------------------------------------------------------------------------------------------------

export default function ModalPopup(props) {
    const { children, cancel, title, sx } = props;

    const handleCancel = () => {
        cancel(false);
    };

    return (
        <div>
            <Modal open >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: { xs: '10%', sm: '15%', md: '22%' },
                    transform: 'translateY(-50%)',
                    bgcolor: 'background.paper',
                    p: 2,
                    borderRadius: 1.5,
                    width: { xs: 400, sm: 500, md: 680, lg: 900 },
                    maxHeight: 570,
                    ...sx
                }}>

                    <Stack direction='row' alignItems="center" justifyContent='space-between' mb={1}>
                        <Typography variant='h6'>
                            {title}
                        </Typography>
                        <IconButton onClick={handleCancel} sx={{ p: 0 }}>
                            <Iconify icon="ant-design:close-square-outlined" width='24px' height='24px' />
                        </IconButton>
                    </Stack>
                    <Box>
                        {children}
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}
